import * as Actions from 'reducks/schedule/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ScheduleReducer = (state = initialState.schedule, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_SCHEDULES:
      return {
        ...state,
        schedules: [...action.payload],
      }
    case Actions.FETCH_SCHEDULES:
      return {
        ...state,
        schedules: [...action.payload],
      }
    case Actions.INIT_SCHEDULES:
      return {
        ...state,
        schedules: [],
      }
    default:
      return state
  }
}
